import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { getAdditionalListOfGoodsFiles } from "../../../adapters/dashboard/dashboardAdapater";
import config from "../../../config/config";

export function ListOfGoodsModal(props) {
  const { isOpen, toggle, estimateId } = props;
  const [list, setList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const data = { estimate_id: estimateId };
        const res = await getAdditionalListOfGoodsFiles(data);
        if (res.data.meta.status === "OK" && res.data.meta.code === 200) {
          setIsLoading(false);
          setList(res.data.data.files_list);
        } else {
          setIsLoading(false);
          setError(true);
        }
      } catch (e) {
        setIsLoading(false);
        if (e.response !== undefined) {
          if (e.response.data.status === 404) {
            setList([]);
          }
        } else {
          setError(true);
          console.error("An Error occurred", e);
        }
      }
    };
    loadData();
  }, [estimateId]);
  const JSX = (
    <Modal
      isOpen={isOpen}
      centered={true}
      fade={false}
      className={"modal-dialog modal-lg"}
    >
      <ModalHeader>
        {" "}
        <h3> List of Goods for Move {estimateId} </h3>
      </ModalHeader>
      <ModalBody className="text-center">
        <div class="container-fluid img-list-container list-of-goods-default list-of-goods-items-list">
          {isLoading === true && (
            <div className="py-5 my-5">
              <Spinner /> Loading...{" "}g
            </div>
          )}
          {error === true && (
            <div className="py-5 my-5">
              An Error Occurred, Please try again later.{" "}
            </div>
          )}
          {list !== null && list.length === 0 && (
            <div className="py-5 my-5">No Files. </div>
          )}
          <div class="row">
            {list !== null &&
              list.map((fileSrc) => {
                return (
                  <div class="col-sm-12 col-md-4 mb-1">
                    <div class="img-container mb-2 p-3 border d-flex flex-column align-items-center justify-content-center">
                      <img
                        class="img-fluid img-list-item"
                        src={`${
                          config.mainDomain
                        }customer/additional_files/${estimateId}/${fileSrc}`}
                        alt=""
                      />
                      <a
                        href={`${
                          config.mainDomain
                        }customer/additional_files/${estimateId}/${fileSrc}`}
                        class="btn btn-sm w-100"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i class="fa fa-download"></i> Download
                      </a>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          class="btn btn-sm btn-dark"
          onClick={() => {
            toggle();
          }}
        >
          Close
        </button>
        <div class="mt-3"></div>
      </ModalFooter>
    </Modal>
  );
  return JSX;
}
